export const constant = (val) => (..._args) => val;
export var Kinds;
(function (Kinds) {
    Kinds["Initialized"] = "Initialized";
    Kinds["Pending"] = "Pending";
    Kinds["Failure"] = "Failure";
    Kinds["Success"] = "Success";
})(Kinds || (Kinds = {}));
/** A RemoteData object that represents a state of being initialized. */
export class Initialized {
    kind = Kinds.Initialized;
}
/** A RemoteData object that represents a state of being pending. */
export class Pending {
    kind = Kinds.Pending;
}
/** A RemoteData object that represents a state of failure. */
export class Failure {
    error;
    kind = Kinds.Failure;
    constructor(error) {
        this.error = error;
        if (error === null || error === undefined)
            throw new TypeError('Parameter "error" is required');
    }
}
/** A RemoteData object that represents a state of success. */
export class Success {
    data;
    kind = Kinds.Success;
    constructor(data) {
        this.data = data;
        if (data === null || data === undefined)
            throw new TypeError('Parameter "data" is required');
    }
}
/** A RemoteData error that represents an unknown state. */
class NeverError extends Error {
    constructor(value) {
        super(`Unknown RemoteData state: ${value}`);
    }
}
/**
 * Takes a `RemoteData` object and callbacks for all possible states and returns the result of
 * the corresponding callback.
 */
export function fold(initialized, pending, failure, success) {
    return (state) => {
        switch (state.kind) {
            case Kinds.Initialized:
                return initialized();
            case Kinds.Pending:
                return pending();
            case Kinds.Failure:
                return failure(state.error);
            case Kinds.Success:
                return success(state.data);
            default:
                throw new NeverError(state);
        }
    };
}
export const isInitialized = (obj) => obj instanceof Initialized;
export const isPending = (obj) => obj instanceof Pending;
export const isSuccess = (obj) => obj instanceof Success;
export const isFailure = (obj) => obj instanceof Failure;
export const isRemoteData = (obj) => isInitialized(obj) || isPending(obj) || isSuccess(obj) || isFailure(obj);
export const isResolved = (obj) => isFailure(obj) || isSuccess(obj);
/** Like `fold`, but returns `undefined` for all states except `Success` which returns the value. */
export function foldSuccess(state) {
    return fold(constant(undefined), constant(undefined), constant(undefined), (x) => x)(state);
}
